import type { FC, PropsWithChildren } from 'react';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import { InnerErrorBoundary } from '@pflegenavi/frontend/layout';

const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => (
  <InnerErrorBoundary
    home={nhAppMainPages.HOME}
    supportEmail="support@pflegenavi.at"
  >
    {children}
  </InnerErrorBoundary>
);

export default ErrorBoundary;
